import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeading } from "../components/Reveal";
import { ExperienceCard } from "../components/ExperienceCard";
import { api } from "../lib/api";

export default function Experiences() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [theme, setTheme] = useState(searchParams.get("theme") || "All");

  useEffect(() => {
    api.list("experiences").then((d) => { setItems(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const themes = ["All", ...new Set(items.map((i) => i.theme).filter(Boolean))];
  const filtered = theme === "All" ? items : items.filter((i) => i.theme === theme);

  return (
    <main className="pt-40 pb-28">
      <Seo title="Immersive Experiences" path="/experiences"
        description="Free-roaming VR and XR experiences — history, space, nature, ancient civilizations, art, science and adventure. VR experiences India." />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <SectionHeading overline="Immersive Experiences"
          title={<>Large-Scale Worlds. <span className="italic text-zinc-400">Real Footsteps.</span></>} />
        <Reveal delay={0.15} className="max-w-2xl mt-6">
          <p className="text-zinc-400 font-light leading-relaxed">
            Free-roaming VR and XR experiences for museums, malls, cultural attractions, entertainment venues and dedicated immersive destinations — supporting installations from roughly 100 to 10,000+ sq ft.
          </p>
        </Reveal>
        {!loading && themes.length > 2 && (
          <div className="flex flex-wrap gap-2 mt-12" data-testid="experiences-theme-filters">
            {themes.map((t) => (
              <button key={t} onClick={() => setTheme(t)} data-testid={`experiences-theme-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`px-5 py-2.5 rounded-full text-xs font-mono uppercase tracking-[0.12em] transition-all duration-300 ${theme === t ? "bg-white text-black" : "border border-white/15 text-zinc-400 hover:text-white"}`}>
                {t}
              </button>
            ))}
          </div>
        )}
        {loading ? (
          <p className="mt-20 text-zinc-500 font-mono text-sm" data-testid="experiences-loading">Loading experiences…</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10" data-testid="experiences-grid">
            {filtered.map((x, i) => (
              <Reveal key={x.id} delay={i * 0.06}><ExperienceCard item={x} type="experiences" index={i} /></Reveal>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
